import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import { useState } from "react";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const LegalPropertyAddressInformation = ({ legalAddressInfoList }) => {

  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

 const maxSteps = validate(legalAddressInfoList) ?  legalAddressInfoList.length : 0;

 const handleBack = () => {
   setActiveStep((prevActiveStep) => prevActiveStep - 1);
 };

 const handleNext = () => {
   setActiveStep((prevActiveStep) => prevActiveStep + 1);
 };

 const legalPropertyAddressInfoComponent = () => {
    const legalPropAddressInfo = validate(legalAddressInfoList) ? legalAddressInfoList[activeStep] : undefined;
    return(
        <Grid container rowSpacing={0} columnSpacing={2}>
           <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Address ID"
                 variant="standard"
                 placeholder="Enter Address ID"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.addressId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Internal Application ID"
                 variant="standard"
                 placeholder="Enter Internal Application ID"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.internalApplicationId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Internal Legal ID"
                 variant="standard"
                 placeholder="Enter Internal Legal ID"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.internalLegalId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Plot Number"
                 variant="standard"
                 placeholder="Enter Plot Number"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.plotNo : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Door Number"
                 variant="standard"
                 placeholder="Enter Door Number"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.doorNo : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="North By"
                 variant="standard"
                 placeholder="Enter North By"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.northBy : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="East By"
                 variant="standard"
                 placeholder="Enter East By"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.eastBy : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="West By"
                 variant="standard"
                 placeholder="Enter West By"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.westBy : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="South By"
                 variant="standard"
                 placeholder="Enter South By"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.southBy : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="State Code"
                 variant="standard"
                 placeholder="Enter State Code"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.stateCode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="State"
                 variant="standard"
                 placeholder="Enter State"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.state : ""}
               />
               </Grid>
           <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="District Code"
                 variant="standard"
                 placeholder="Enter District Code"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.districtCode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="District"
                 variant="standard"
                 placeholder="Enter District"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.district : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Taluk Code"
                 variant="standard"
                 placeholder="Enter Taluk Code"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.talukCode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Taluk"
                 variant="standard"
                 placeholder="Enter Taluk"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.taluk : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Town Code"
                 variant="standard"
                 placeholder="Enter Town Code"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.townCode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Town"
                 variant="standard"
                 placeholder="Enter Town"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.town : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Village Code"
                 variant="standard"
                 placeholder="Enter Village Code"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.villageCode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Village"
                 variant="standard"
                 placeholder="Enter Village"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.village : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Survey Number"
                 variant="standard"
                 placeholder="Enter Survey Number"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.surveyNo : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Additional Survey Number"
                 variant="standard"
                 placeholder="Enter Additional Survey Number"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.additionalSurveyNo : ""}
               />
               </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="SRO"
                 variant="standard"
                 placeholder="Enter SRO"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.sro : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="SRO District Code"
                 variant="standard"
                 placeholder="Enter SRO District Code"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.sroDistrictCode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="SRO District"
                 variant="standard"
                 placeholder="Enter SRO District"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.sroDistrict : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="SRO Pincode"
                 variant="standard"
                 placeholder="Enter SRO Pincode"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.sroPincode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Remarks"
                 variant="standard"
                 placeholder="Enter Remarks"
                 disabled={true}
                 value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.remarks : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
               <CustomTextField
                  type="text"
                  label="Created By"
                  variant="standard"
                  placeholder="Enter Created By"
                  disabled={true}
                  value={ legalPropAddressInfo !== undefined ? legalPropAddressInfo.createdBy : ""}
                />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
               <CustomTextField
                  type="text"
                  label="Modified By"
                  variant="standard"
                  placeholder="Enter Modified By"
                  disabled={true}
                  value={legalPropAddressInfo !== undefined ? legalPropAddressInfo.modifiedBy : ""}
                />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
               <CustomTextField
                  type="text"
                  label="Created Date"
                  variant="standard"
                  placeholder="Enter Created Date"
                  disabled={true}
                  value={legalPropAddressInfo !== undefined ? convertDateWithValidation(legalPropAddressInfo.createdDate) : ""}
                />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
               <CustomTextField
                  type="text"
                  label="Modified Date"
                  variant="standard"
                  placeholder="Enter Modified Date"
                  disabled={true}
                  value={legalPropAddressInfo !== undefined ? convertDateWithValidation(legalPropAddressInfo.modifiedDate) : ""}
                />
                </Grid>
               </Grid>
      );
 }

 return(
    <AccordianContainer
    id="accord"
    title="Legal Property Address Information"
    initialOpen={false}
  >
  <Box sx={{ marginTop: "-1%" }}>
  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box sx={{ display: "flex", justifyContent:"center", alignItems: "center", marginBottom: "8px"}}>
                   { maxSteps > 1 && <MobileStepper
                     variant="text"
                     steps={maxSteps}
                     position="static"
                     activeStep={activeStep}
                     sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }} 
                       nextButton={
                       <Button size="small" sx={{ color:"#003f7c" }} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                           Next
                       {theme.direction === 'rtl' ? (
                       <KeyboardArrowLeft />
                       ) : ( <KeyboardArrowRight /> )}
                      </Button>
                    }
                   backButton={
                   <Button size="small" onClick={handleBack} sx={{ color:"#003f7c" }} disabled={activeStep === 0}>
                   {theme.direction === 'rtl' ? (
                       <KeyboardArrowRight />
                   ) : (
                       <KeyboardArrowLeft />
                   )}
                       Back
                   </Button>
               }
               /> }
               </Box>
               </Grid>
               { legalPropertyAddressInfoComponent() }
   </Box>
  </AccordianContainer>
 );
}

export default LegalPropertyAddressInformation;